/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-13 15:41:06
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {MenuConfigDOI} from "./api/menuConfigApi";
import MenuConfigService from "./service/menuConfigService";
import './menuConfig.less';

@Component({name: 'menu-config'})
export default class MenuConfig extends BasicSearchPage<MenuConfigService, MenuConfigDOI.RowDataI, MenuConfigDOI.QueryRowDataParamsI> {

	@override
	loadService () {
		this.service = new MenuConfigService(this)
	}
}